import * as React from "react";
import {UploadFile} from "../../BackendFacade/apiCalls";
import {DpasPopup} from "../../Interfaces/IFiles";
import {useMain} from "../../../../Utils/SessionControls/mainContext";
import OdxModal from "../../../../OdxComponents/NativeOdx/Modal/Odx-Modal";
import OdxInputField from "../../../../OdxComponents/NativeOdx/FormControls/Odx-InputField";
import {UserRoles} from "../../../../Utils";
import {HubPathRouting} from "../../../../HubFramework/pathBuilder";

export interface IFilesUpload {
    setPopup: (popup: DpasPopup) => void;
    directoryType: string;
    refreshDirectory: () => void;
    uploadPathParam: string;
}

const FilesUpload: React.FC<IFilesUpload> = ({
                                                 setPopup,
                                                 directoryType,
                                                 refreshDirectory,
                                                 uploadPathParam,
                                             }) => {
    const [filesSelectedForUpload, setFilesSelectedForUpload] = React.useState<
        File[] | undefined
    >(undefined);
    const [uploadPath, setUploadPath] = React.useState<string>(uploadPathParam);
    const baseId = 'dpas-files-upload';

    const {setLoading, createErrorToast} = useMain();

    const dpasPopupClose = () => {
        setPopup(DpasPopup.None);
    };

    const cleanPath = (path: string) => {
        if (path.length > 150) {
            path = path.substring(0, 150);
        }
        let ret = path
            .split("/")
            .filter((x) => x !== "")
            .join("/");
        if (ret !== "") {
            ret += "/";
        }
        return ret;
    };

    const UploadFileSubmit = () => {
        setLoading(true);
        if (filesSelectedForUpload) {
            filesSelectedForUpload.forEach((file) => {
                UploadFile(cleanPath(uploadPath), file, directoryType)
                    .then((data) => {
                        if (!data.success) {
                            createErrorToast("Error", data.message);
                        } else {
                            setPopup(DpasPopup.None);
                            setFilesSelectedForUpload(undefined);
                            setUploadPath("");
                            refreshDirectory();
                        }
                        setLoading(false);
                    })
                    .catch((error) => {
                        createErrorToast("Error", error.message);
                        setLoading(false);
                    });
            });
        }
    };

    const submitButton = (
        <odx-button
            key="submit"
            id={`OdxButton_${baseId}-submit-btn`}
            variant="primary"
            size="lg"
            type="button"
            disabled={
                !uploadPath || !filesSelectedForUpload || filesSelectedForUpload.length === 0 ? true : undefined
            }
            onClick={UploadFileSubmit}
        >
            Submit
        </odx-button>
    );

    return (
        <OdxModal
            size="medium"
            variant="default"
            title="Upload File"
            isOpen={true}
            id={baseId}
            onClose={dpasPopupClose}
            footerButtons={[
                <odx-button
                    key="close"
                    id={`OdxButton_${baseId}-cancel-btn`}
                    variant="neutral"
                    size="lg"
                    type="button"
                    className="mr-[10px]"
                    onClick={dpasPopupClose}
                >
                    Close
                </odx-button>,
                submitButton,
            ]}
        >
            <div>
                <div className={"mb-[15px]"}>
                    <div className="odx-grid-col--3">Path</div>
                    <div>
                        <OdxInputField
                            isRequired={true}
                            value={uploadPath}
                            id={`${baseId}-path`}
                            label={"Path"}
                            onChange={(event) => setUploadPath(event.target.value)}
                        />
                        <div>
                            You can type new paths if you want to create a new directory. For example, `/dir` will result in `/dir/file.txt`
                        </div>
                    </div>
                </div>
                <div>
                    <br/>
                    <div id={`${baseId}-file-count`}>
                            {filesSelectedForUpload && filesSelectedForUpload.length > 0
                                ? <div>{filesSelectedForUpload.length} Files selected </div>
                                : "No files selected"}
                    </div>
                </div>
                <div className={"mb-[15px]"}>
                    <br/>
                    <input
                        id={`${baseId}-input`}
                        type="file"
                        multiple
                        onChange={e => setFilesSelectedForUpload(Array.from(e.target.files))}
                        style={{display: "none"}}
                    />

                    <label
                        htmlFor={`${baseId}-input`}
                        style={{
                            padding: "6px 12px",
                            background: "#0091f7",
                            color: "#fff",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                            userSelect: "none"
                        }}
                    >
                        Choose file
                    </label>
                </div>
            </div>
        </OdxModal>
    );
};

export default FilesUpload;
